import swal from "sweetalert";
import {
  CHANGE_USER_PASSWORD_FAIL,
  CHANGE_USER_PASSWORD_REQUEST,
  CHANGE_USER_PASSWORD_SUCCESS,
  CREATE_USER_FAIL,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  FETCH_USER_AUTH_FAIL,
  FETCH_USER_AUTH_REQUEST,
  FETCH_USER_AUTH_SUCCESS,
  FETCH_USER_CV_FAIL,
  FETCH_USER_CV_REQUEST,
  FETCH_USER_CV_SUCCESS,
  FETCH_USER_FAIL,
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  PROFILE_USER_REQUEST,
  PROFILE_USER_SUCCESS,
  UPDATE_EMAIL_USER_FAIL,
  UPDATE_EMAIL_USER_REQUEST,
  UPDATE_EMAIL_USER_SUCCESS,
} from "../../ActionType/UserType/UserType";
import { api } from "../../Api/api";
import { getToken } from "../login";

export const getUsersAction =
  (page, perPage = 15) =>
  async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params: {
        page,
        perPage,
      },
    };

    dispatch({
      type: FETCH_USER_REQUEST,
      payload: [],
    });
    try {
      const response = await api.get("user", config);
      const { status, data } = response;
      if (status == 200) {
        dispatch({
          type: FETCH_USER_SUCCESS,
          payload: { data: data.users, total: data.total },
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_USER_FAIL,
        payload: [],
      });
    }
  };

export const getUsersAuthAction = () => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: FETCH_USER_AUTH_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get("user/userAuth", config);
    const { status, data } = response;
    // console.log(data);
    if (status == 200) {
      dispatch({
        type: FETCH_USER_AUTH_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    console.log(error);

    if(error.response.status==401){
      localStorage.removeItem("token");
      localStorage.removeItem("branch_id");
      dispatch({
        type: FETCH_USER_AUTH_FAIL,
        payload: [],
      });
    }
    dispatch({
      type: FETCH_USER_AUTH_FAIL,
      payload: [],
    });
  }
};

export const createUserAction =
  (formValues, handlClearInput) => async (dispatch) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      };
      const formData = new FormData();
      for (const key in formValues) {
        if (key == "email") {
          formData.append(key, formValues[key]);
          break;
        }
      }
      formData.append("password", "12345678");

      dispatch({
        type: CREATE_USER_REQUEST,
      });

      const response = await api.post("user/create", formData, config);

      if (response.status == 201) {
        dispatch(createUserCVAction(formValues, response.data.id));
        dispatch(createUserInfoAction(formValues, response.data.id));
        handlClearInput();
        swal({
          title: "Good job!",
          text: "User was saved Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
        dispatch({
          type: CREATE_USER_SUCCESS,
          payload: response.data,
        });
      }
    } catch (error) {
      if (error.response.status == 422) {
        dispatch({
          type: CREATE_USER_FAIL,
          payload: [],
          error: error.response.data.errors,
        });
      }
    }
  };

export const createUserInfoAction =
  (formValues, user_id) => async (dispatch) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          // "Content-Type": "multipart/form-data",
        },
      };
      const formData = new FormData();
      for (const key in formValues) {
        if (key !== "images" || key !== "email" || key !== "password") {
          formData.append(key, formValues[key]);
        }
      }
      formData.append("user_id", user_id);
      dispatch({
        type: CREATE_USER_REQUEST,
      });
      const response = await api.post("user/createUserInfo", formData, config);

      if (response.status == 201) {
        dispatch({
          type: CREATE_USER_SUCCESS,
          payload: response.data,
        });
      }
    } catch (error) {
      console.log(error);
      if (error.response.status == 422) {
        dispatch({
          type: CREATE_USER_FAIL,
          payload: [],
          error: error.response.data.errors,
        });
      }
    }
  };

export const createUserCVAction = (formValues, user_id) => async (dispatch) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "multipart/form-data",
      },
    };
    const formData = new FormData();
    for (const key in formValues) {
      if (key === "images") {
        for (let i = 0; i < formValues[key].length; i++) {
          formData.append(key + "[]", formValues[key][i]);
        }
      }
    }
    formData.append("user_id", user_id);
    dispatch({
      type: CREATE_USER_REQUEST,
    });
    const response = await api.post("user/createUserCv", formData, config);
    if (response.status == 201) {
      dispatch({
        type: CREATE_USER_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    if (error.response.status == 422) {
      dispatch({
        type: CREATE_USER_FAIL,
        payload: [],
        error: error.response.data.errors,
      });
    }
  }
};

export const userChangePasswordAction = (id, password) => async (dispatch) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    dispatch({
      type: CHANGE_USER_PASSWORD_REQUEST,
    });
    const response = await api.patch(
      `user/change-password/${id}`,
      { password },
      config
    );
    console.log(response);
    if (response.status == 200) {
      swal({
        title: "Good job!",
        text: "User was saved Successfully !",
        icon: "success",
        button: "OK",
        timer: 2000,
      });
      dispatch({
        type: CHANGE_USER_PASSWORD_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    console.log(error);
    if (error.response.status == 422) {
      dispatch({
        type: CHANGE_USER_PASSWORD_FAIL,
        payload: [],
        error: error.response.data.errors,
      });
    }
  }
};

export const userUpdateEmailAction =
  (id, email, formatData) => async (dispatch) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          // "Content-Type": "multipart/form-data", // Ensu
        },
      };

      dispatch({
        type: UPDATE_EMAIL_USER_REQUEST,
      });

      const response = await api.patch(
        `user/update-email/${id}`,
        { email },
        config
      );

      if (response.status === 200) {
        dispatch(updateUserInfoAction(formatData));

        swal({
          title: "Good job!",
          text: "User was Updated Successfully!",
          icon: "success",
          button: "OK",
          timer: 2000,
        });

        dispatch({
          type: UPDATE_EMAIL_USER_SUCCESS,
          payload: response.data,
        });
      }
    } catch (error) {
      console.error("Patch error:", error); // Debugging

      if (error.response.status === 422) {
        dispatch({
          type: UPDATE_EMAIL_USER_FAIL,
          payload: [],
          error: error.response.data.errors,
        });
      }
    }
  };

export const updateUserInfoAction = (formValues) => async (dispatch) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "multipart/form-data", // Ensure this is set correctly
      },
    };

    const formData = new FormData();
    for (const key in formValues) {
      formData.append(key, formValues[key]);
    }

    const response = await api.post(
      `user/updateUserInfo/${formValues.userInfoId}`,
      formData,
      config
    );

    if (response.status === 200) {
      dispatch({
        type: CREATE_USER_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    if (error.response && error.response.status === 422) {
      dispatch({
        type: CREATE_USER_FAIL,
        payload: [],
        error: error.response.data.errors,
      });
    }
  }
};

export const resetPasswordAction = (userId) => async (dispatch) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    const response = await api.put(`user/reset-password/${userId}`, {}, config);
    if (response.status == 200) {
      swal({
        title: "Good job!",
        text: "Reset Password  Successfully!",
        icon: "success",
        button: "OK",
        timer: 2000,
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const getUserCvAction = (userId) => async (dispatch) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({
      type: FETCH_USER_CV_REQUEST,
    });
    const response = await api.get(`user/user-cv/${userId}`, config);
    console.log(response.data);
    if (response.status == 200) {
      dispatch({
        type: FETCH_USER_CV_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_USER_CV_FAIL,
      error: error.response.data.errors,
    });
    // console.log(error);
  }
};

export const profilImageUserAction = (ids, id) => async (dispatch) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({
      type: PROFILE_USER_REQUEST,
    });
    const response = await api.post(`user/profile-image`, { ids, id }, config);
    
    if (response.status == 200) {
      dispatch(getUsersAuthAction())
      dispatch(getUsersAuthAction())
      dispatch({
        type: PROFILE_USER_SUCCESS,
        payload: response.data,
      });
      swal({
        title: "Good job!",
        text: "Change Profile Image Successfully!",
        icon: "success",
        button: "OK",
        timer: 2000,
      });
    }
  } catch (error) {
    dispatch({
      type: PROFILE_USER_SUCCESS,
      error: error.response.data.errors,
    });
    console.log(error);
  }
};
